define('meetings/join-link/join-link',['require','knockout','plugins/router','web-urls','meetings/lib/telemetry-client/telemetry-service','mixpanel-helper'],function (require) {
    var ko = require('knockout');
    var router = require('plugins/router');
    var webUrls = require('web-urls');
    var baseUrl = webUrls.get('baseUrl');
    var telemetrySvc = require('meetings/lib/telemetry-client/telemetry-service');
    var mixpanelHelper = require('mixpanel-helper');

    var self = this;

    self.isJoinMeeting = ko.observable(true);
    self.isJoinSelected = ko.observable(false);
    self.joinMeetingId = ko.observable('').extend({
        rateLimit: {
            timeout: 900,
            method: 'notifyWhenChangesStop'
        },
        pattern: '^[0-9]{3}[-]{0,1}[0-9]{3}[-]{0,1}[0-9]{3}$| ^[0-9]{9}$'
    });

    self.toggleJoinMeetingShown = function () {
        self.isJoinMeeting(!self.isJoinMeeting());
        self.isJoinSelected(true);
    };

    self.joinMeeting = function () {
        if (self.joinMeetingId.isValid() && self.joinMeetingId().length > 0) {
            var sessionTrackingId = telemetrySvc.getSessionTracking('mfe');
            var unformattedMeetingId = self.joinMeetingId().replace(/-/g, '');
            var sessionParam = sessionTrackingId ? '?sessionTrackingId=' + sessionTrackingId : '';
            var url = '/join/' + unformattedMeetingId + sessionParam;
            var properties = {
                ID: unformattedMeetingId
            };
            mixpanelHelper.trackLink(url, 'Join a Meeting', properties);

            telemetrySvc.report({
                ev_name: 'joinStart',
                sa_method: baseUrl + '::joining_meeting',
                ga_meetingId: self.joinMeetingId(),
                ga_id_sessiontracking: sessionTrackingId
            });
        } else {
            self.isJoinSelected(true);
        }
    };

    self.showCornerJoinLink = ko.computed(function () {
        if (router.activeInstruction() && self.composeJoinLink) {
            return router.activeInstruction().fragment !== 'meetings/past' && self.composeJoinLink();
        }
        return undefined;
    });

    return {
        joinMeetingId: self.joinMeetingId,
        joinMeeting: self.joinMeeting
    };
});

